"use strict";
/*
* Created on 23.04.2019
*/

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var StateDomainObject_1 = require("../../core/model/StateDomainObject");
/**
 * Every day of a downtime has a record in this table.
 * If it is a downtime during a promotion, then promotion_id is set.
 * If there are more overlapping promotions on a given day, then the amount cannot be added.
 * The amount is lost sales on that day, it's not a break-up to the promotion.
 * @author ZSr
 */


var Stockout =
/*#__PURE__*/
function (_StateDomainObject_1$) {
  _inherits(Stockout, _StateDomainObject_1$);

  /**
   * @param id internal id
   * @param externalId
   * @param siteId identification of sites
   * @param promotionId internal id of a promotion
   * @param productId internal od of a product
   * @param dateOfStockout date when stockout occur
   * @param amount number of stockout pieces
   * @param stateFlags
   */
  function Stockout(id, externalId, siteId, promotionId, productId, dateOfStockout, amount, stateFlags) {
    var _this;

    _classCallCheck(this, Stockout);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Stockout).call(this, stateFlags));
    _this.id = id;
    _this.externalId = externalId;
    _this.siteId = siteId;
    _this.promotionId = promotionId;
    _this.productId = productId;
    _this.dateOfStockout = dateOfStockout;
    _this.amount = amount;
    _this.stateFlags = stateFlags;
    return _this;
  }

  return Stockout;
}(StateDomainObject_1.StateDomainObject);

exports.Stockout = Stockout;

Stockout.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(Stockout.name);
  return {
    id: builder.id('id'),
    externalId: builder.str('externalId'),
    siteId: builder.str('siteId'),
    promotionId: builder.opt(builder.str('promotionId')),
    productId: builder.str('productId'),
    dateOfStockout: builder.date('dateOfStockout', DateParser_1.DateParser.ISO_PATTERN),
    amount: builder.bigNum('amount'),
    stateFlags: builder.flags('stateFlags', EntityStateFlag_1.EntityStateFlag)
  };
}();